export default __webpack_public_path__ + "static/smallrepair-3520d66882f89930a625d2dd3b37f08e.jpg";